import { BrowserModule } from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import {
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi
} from '@angular/common/http';
import { UiModule } from './ui/ui.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import {RemoveAccountComponent} from "./auth/remove-account/remove-account.component";
import {GlobalErrorHandler} from "./core/error-handler/global-error-handler.service";
import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  includeBearerTokenInterceptor,
  provideKeycloak
} from 'keycloak-angular';

@NgModule({ declarations: [
        AppComponent,
        RemoveAccountComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot(),
        NgxPaginationModule,
        AppRoutingModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        UiModule,
      ],
      providers: [
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(
          withInterceptors([includeBearerTokenInterceptor]),
          withInterceptorsFromDi()
        ),
        provideKeycloak({
          config: {
            url: '/auth',
            realm: 'bergh-realm',
            clientId: 'bergh-frontend'
          },
          initOptions: {
            onLoad: 'check-sso',
            pkceMethod: 'S256',
            checkLoginIframe: false
          },
          providers: [
            {
              provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
              useValue: [
                createInterceptorCondition<IncludeBearerTokenCondition>({
                  urlPattern: /^\/api\//
                }),
                createInterceptorCondition<IncludeBearerTokenCondition>({
                  urlPattern: /^\/user\//
                }),
                createInterceptorCondition<IncludeBearerTokenCondition>({
                  urlPattern: /^\/admin\//
                })
              ]
            }
          ]
        })
    ] })
export class AppModule { }
